export default __webpack_public_path__ + "d42dad28f6470e5162c23aa339df3d77.woff";